import { render, staticRenderFns } from "./XhProuctCate.vue?vue&type=template&id=50bdb012&scoped=true"
import script from "./XhProuctCate.vue?vue&type=script&lang=js"
export * from "./XhProuctCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bdb012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50bdb012')) {
      api.createRecord('50bdb012', component.options)
    } else {
      api.reload('50bdb012', component.options)
    }
    module.hot.accept("./XhProuctCate.vue?vue&type=template&id=50bdb012&scoped=true", function () {
      api.rerender('50bdb012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhProuctCate.vue"
export default component.exports